import styled from 'styled-components';

export const Content = styled.div`
  height: 100%;
  font-size: ${(props) => props.theme.fontSize.base};
  color: ${(props) => props.theme.colors.primary};
`;

export const Title = styled.h3`
  margin: 0 0 ${(props) => props.theme.spacing.md};
  font-size: ${(props) => props.theme.fontSize.lg};
  font-weight: 500;
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ListItem = styled.li`
  padding: ${(props) => props.theme.spacing.sm} 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.greyFive};
  &:last-child {
    border-bottom: none;
  }
`;
